// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input__Input--3D9b3","textarea-icon":"Input__textarea-icon--cT1fS","placeholder":"Input__placeholder--1alps","focused":"Input__focused--1x_Tl"};